import { SocialMediaBtns } from "@/components/SocialMediaBtns";
import { TeamList } from "@/components/TeamList";
import { Button, Center, useMantineTheme } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { FaHeart } from "react-icons/fa6";
import { Link } from "react-router-dom";

import BG1 from "@/assets/images/bg1.jpg?format=webp"
import BG2 from "@/assets/images/bg2.jpg?format=webp"
import BG3 from "@/assets/images/bg3.jpg?format=webp"
import { SelectedTeamProvider } from "@/lib/providers/SelectedTeamProvider";
import { PatternBackground } from "@/components/atoms/PatternBackground";

export const HomePage = () => {
  const theme = useMantineTheme();
  const { data: isOpen } = useQuery({
    queryKey: ["registrations", "open"],
    queryFn: async () => {
      const resp = await fetch("/api/registrations/open");
      if (!resp.ok) throw new Error("Failed to fetch if registrations are open");
      const data = await resp.text();
      return data == "true";
    }
  });
  const bgNum = useMemo(() => Math.floor(Math.random() * 3), []);

  return (
    <div>
      <section
        className="flex min-h-[100vh] snap-start flex-col items-center gap-4 bg-cover bg-center text-center font-[Unbounded] text-white"
        style={{
          backgroundImage: `url(${[BG1, BG2, BG3][bgNum]})`
        }}
      >
        <a href="https://studentkickoff.be" className="mt-28 w-64">
          <img
            src="/images/logo_long.png"
            alt="Student Kick-Off logo"
            className="object-fit h-full w-full"
          />
        </a>
        <PatternBackground pattern={1} opacity={90} className="rounded-xl p-8 m-8 overflow-hidden">
          <div className="space-y-4">
            <p className="text-3xl sm:text-5xl font-semibold uppercase">Festival zkt studenten!</p>
            <p className="text-lg sm:text-2xl">
              Wil jij deel uitmaken van het grootste eendagsfestival van België?
            </p>
            <p className="text-sm sm:text-xl">{isOpen ? "Join de crew voor 2026!" : "De sollicitaties zijn gesloten voor deze editie! Hou onze socials in de gaten om op de hoogte te blijven wanneer deze opnieuw open gaan"}</p>
            {isOpen && <p className="text-sm sm:text-xl">Je hebt tot en met 1 februari 2026 om te solliciteren</p>}
            <p className="text-xs sm:text-lg">
              De crew van Student Kick-Off werkt op vrijwillige basis.
            </p>
            <Button
              disabled={!isOpen}
              style={{ fontFamily: theme.fontFamily }}
              className="shadow-xl"
              variant="white"
              component={Link}
              to={isOpen ? "/join-us" : ""}
              size="lg"
            >
              Join us!
            </Button>
          </div>
        </PatternBackground>
      </section>
      <section className="snap-start">
        {!isOpen && (
          <p className="text-center font-semibold text-2xl py-2 animate-pulse">De sollicitaties zijn gesloten voor deze editie! Hou onze socials in de gaten om op de hoogte te blijven wanneer deze opnieuw open gaan</p>
        )}
        <SelectedTeamProvider>
          <TeamList disableRankSelection />
        </SelectedTeamProvider>
        {isOpen && (
          <Center className="pt-2">
            <Button component={Link} to="/join-us" size="lg">
              Join us!
            </Button>
          </Center>
        )}
      </section>
      <footer className="mt-2 w-full">
        <SocialMediaBtns />
        <div className="mt-2 flex items-center justify-center text-gray-500 underline">
          <Link to="/login">Login</Link>
        </div>
        <p className="mt-2 flex items-baseline justify-center gap-1 text-gray-500">
          Made with{" "}
          <span>
            <FaHeart size="1rem" className="text-primary/80" />
          </span>{" "}
          by Team IT
        </p>
      </footer>
    </div>
  );
};
